"use client";

import { memo } from "react";
import { affiliateCertifiedData } from "./constants";
import { CertificateSection } from "@/components/screen/global-components/certificate";

const AffiliateCertified = ({ className }: React.ComponentProps<"section">) => {
  return (
    <CertificateSection className={className} {...affiliateCertifiedData} accordionMultiple />
  );
};

export default memo(AffiliateCertified);
